import React from 'react';
import DesktopBlank from '../cookie/DesktopBlank';
import MobileBlank from '../cookie/MobileBlank';

const CookieBanner = ({ acceptCookies }) => {
    const openNewTab = (event) => {
        event.preventDefault();
        const url = 'https://dialzara.com/cookie-policy/';
        const newTab = window.open(url, '_blank');
        newTab.focus();
    };

    return (
        <>
            <DesktopBlank acceptCookies={acceptCookies} openNewTab={openNewTab} />
            <MobileBlank acceptCookies={acceptCookies} openNewTab={openNewTab} />
        </>
    );
};

export default CookieBanner;
